import React, { Component } from 'react';
import '../css/Login.css';
import Notifications, {notify} from 'react-notify-toast';
import AuthService from './AuthService';
import { Link } from 'react-router-dom';
class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            username: "",
            password: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.Auth = new AuthService();
    }
    componentWillMount(){
        if(this.Auth.loggedIn())
            this.props.history.replace('/');
    }
    handleSubmit(e) {
        e.preventDefault();
        this.Auth.login(this.state.username, this.state.password, this.state.designation_id)
            .then(res => {
                this.setState({
                    username: "",
                    password: ""
                });
                this.props.history.replace('/');
            })
            .catch(err => {
                notify.show('Wrong Username or password', "error", 3000);
            });
    }
    handleChange(e) {
        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }
    render() {
        return ( 
            <section className="container_signin">
                <Notifications />
                <section className="card card_signin">
                    <header className="card-content card-header_signin">
                        <h2>Assam Engineering College<br/> Sign In</h2>
                    </header>
                    <section className="card-content">
                        <form className="card-form">
                            <input
                                type="text"
                                placeholder="Username"
                                className="input-box input-box_signin"
                                value={this.state.username}
                                autoComplete="off"
                                onChange={this.handleChange}
                                name="username"
                                required
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                className="input-box input-box_signin"
                                value={this.state.password}
                                autoComplete="off"
                                onChange={this.handleChange}
                                name="password"
                                required
                            />
                            <div className="c-flex">
                                <button onClick={this.handleSubmit}>SUBMIT</button>
                            </div>
                        </form>
                    </section>
                </section>
            </section>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/auth_components/js/Login.js